/**
 * ChatApiService
 * Handles all chat-related API endpoints
 */

import type { HttpClient } from './HttpClient';
import type { ChatRequest, ChatResponse } from '../../api/data-contracts';

/**
 * Chat history entry
 */
export interface ChatHistory {
  messages: Array<{
    role: 'user' | 'assistant';
    content: string;
    sources?: Array<{
      document_id: string;
      title: string;
      score: number;
    }>;
  }>;
}

/**
 * Service for chat operations
 */
export class ChatApiService {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Send a chat request
   */
  public async sendChatRequest(request: ChatRequest): Promise<ChatResponse> {
    return this.httpClient.post<ChatResponse>('/chat', request);
  }

  /**
   * Get chat history
   */
  public async getChatHistory(limit: number = 20): Promise<ChatHistory[]> {
    return this.httpClient.get<ChatHistory[]>('/chat/history', {
      params: { limit },
    });
  }

  /**
   * Delete all chat history for current user
   */
  public async deleteChatHistory(): Promise<{ message: string }> {
    return this.httpClient.delete<{ message: string }>('/chat/history');
  }
}
